// import React from 'react';
// import ModeEditIcon from '@mui/icons-material/ModeEdit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { IconButton } from '@mui/material';

// export const StoreColumns = (handleEdit, handleDelete, handleSortChange) => {
//     return [
//         {
//             field: 'store_number',
//             headerName: 'Store No',
//             minWidth: 50,
//             onClick: () => handleSortChange('store_number'),
//         },
//         {
//             field: 'abbreviation',
//             headerName: 'Abbreviation',
//             minWidth: 100,
//             onClick: () => handleSortChange('abbreviation'),

//         },
//         {
//             field: 'name',
//             headerName: 'Store Name',
//             minWidth: 250,

//         },
//         {
//             field: 'address',
//             headerName: 'Address',
//             minWidth: 300,
//             sortable: true

//         },
//         {
//             field: 'city',
//             headerName: 'City',
//             minWidth: 150,
//             sortable: true

//         },
//         {
//             field: 'state_name',
//             headerName: 'State',
//             minWidth: 100,
//             sortable: true

//         },
//         {
//             field: 'zip',
//             headerName: 'Zip Code',
//             minWidth: 120,
//             sortable: true

//         },
//         {
//             field: 'primary_contact_phone',
//             headerName: 'Phone',
//             minWidth: 120,
//         },
//         {
//             field: 'unit_limit',
//             headerName: 'Unit Limit',
//             minWidth: 100,
//         },
//         {
//             field: 'actions',
//             headerName: 'Actions',
//             width: 150,
//             align: 'right',
//             renderCell: (params) => (
//                 <div>
//                     <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
//                         <ModeEditIcon className='ml-5 edit-color' />
//                     </IconButton>
//                     <IconButton aria-label="delete" onClick={() => handleDelete(params.row)}>
//                         <DeleteIcon className='ml-5 delete-color' />
//                     </IconButton>
//                 </div>
//             ),
//         },
//     ];
// };
import React from 'react';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { IconButton } from '@mui/material';

export const StoreColumns = (handleEdit, handleDelete, handleSortChange) => {
    return [
        {
            field: 'store_number',
            headerName: 'Store No',
            minWidth: 50,
            sortable: true, // Mark the column as sortable
        },
        {
            field: 'abbreviation',
            headerName: 'Abbreviation',
            minWidth: 100,
            sortable: true,
        },
        {
            field: 'name',
            headerName: 'Store Name',
            minWidth: 250,
            sortable: true,
        },
        {
            field: 'address',
            headerName: 'Address',
            minWidth: 300,
            sortable: false,
        },
        {
            field: 'city',
            headerName: 'City',
            minWidth: 150,
            sortable: false,
        },
        {
            field: 'state_name',
            headerName: 'State',
            minWidth: 100,
            sortable: false,
        },
        {
            field: 'zip',
            headerName: 'Zip Code',
            minWidth: 120,
            sortable: false,
        },
        {
            field: 'primary_contact_phone',
            headerName: 'Phone',
            minWidth: 120,
            sortable: false,
        },
        {
            field: 'unit_limit',
            headerName: 'Unit Limit',
            minWidth: 100,
            sortable: false,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            align: 'right',
            sortable: false,
            renderCell: (params) => (
                <div>
                    <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                        <ModeEditIcon className='ml-5 edit-color' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleDelete(params.row)}>
                        <DeleteIcon className='ml-5 delete-color' />
                    </IconButton>
                </div>
            ),
        },
    ];
};
